import { UserStatus } from "@bvhi/backend-api";
import type { ChipProps } from "@bvhi/ui-base";
import { Chip } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";

interface Props {
  readonly status: string;
  readonly hasLoggedIn?: boolean;
  readonly size?: "small" | "medium";
}

export function UserStatusChip({ status, size = "small", hasLoggedIn = false }: Readonly<Props>) {
  const { t } = useTranslation(["enums"]);

  let label = "";
  let color: ChipProps["color"] = "default";

  switch (status) {
    case UserStatus.ACTIVE:
      label = t("enums:enums.user.status.active");
      color = "success";
      break;

    case UserStatus.INACTIVE:
      label = t("enums:enums.user.status.inactive");
      color = "warning";
      break;

    case UserStatus.DELETED:
      label = t("enums:enums.user.status.deleted");
      color = "error";
      break;
  }

  if (!hasLoggedIn) {
    label = t("enums:enums.user.status.not.logged.in");
    color = "default";
  }

  return <Chip color={color} label={label} size={size} />;
}
